import { render, staticRenderFns } from "./DFlex.vue?vue&type=template&id=3c0d2d92&scoped=true&"
import script from "./DFlex.vue?vue&type=script&lang=js&"
export * from "./DFlex.vue?vue&type=script&lang=js&"
import style0 from "./DFlex.vue?vue&type=style&index=0&id=3c0d2d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d2d92",
  null
  
)

export default component.exports